<template>
  <div>
    <div class="hour-cost-item" v-for="(item, index) in list" :key="index" @click="gotoDetail(item)">
      <div class="contain">
        <div class="class-status" v-if="signStatus[item.courseStudentStatus]">
          <span class="status-name">{{signStatus[item.courseStudentStatus]}}<span class="makeup" v-if="item.identity==5">(补课)</span></span>
          <span v-if="item.courseAmount">
            <!-- 课时<span class="hour-cost" >{{item.courseCost>0?'-':''}}{{item.courseCost}}</span> -->
            <span class="hour-cost" >{{item.courseAmount}}</span>{{lessonUnit}}
          </span>
        </div>      
        <div class="time">
          {{getDate(item.startTime)}}
          {{app.base.weekMap[new Date(item.startTime).getDay()] || '--'}}
          {{getDate(item.startTime, 'hh:mm')}}
          <span>-</span>
          <span>{{getDate(item.endTime, 'hh:mm')}}</span>
        </div>
        <div class="cname van-ellipsis">
          <template v-if="item.courseArrange && item.coursePlanType === 0">
            {{item.className}}
          </template>
          <template v-else> 
            {{item.curriculumName }}
          </template>
        </div>
        <div class="class-infos">
          <div class="teacher van-ellipsis">
            <van-icon class-prefix="vxs-icon" name="laoshi1" />
            {{item.teacherName}}
          </div>
          <div class="class-room van-ellipsis">
            <van-icon class-prefix="vxs-icon" name="jiaoshi" />
            {{item.classRoomName || '-'}}
          </div>
        </div>
        <div class="course-content van-ellipsis" v-if="item.courseContent ">
          上课内容：{{item.courseContent}}
        </div>
      </div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="暂无点名记录"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
    </van-empty>
  </div>
</template>

<script>
// 点名记录组件，家长/机构端复用
export default {
  name: 'CallTheRoll',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    chargeType: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      // 根据后端接口配置的各种出勤状态
      signStatus: ['', '出勤', '迟到', '请假', '未到'],
    }
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  methods: {
    gotoDetail(item){
      this.$router.push(`/courseArrange/${item.courseArrangeId}`)
    },
    // 获取UI要求的MM-dd日期结构
    getDate (date, reg = 'MM-dd') {
      if (!date) return '--/--';
      return app.tool.date.formatDatetime(date, reg);
    },
    // showStopReason (message = '暂无停课原因。') {
    //   this.$dialog.alert({
    //     title: '停课原因',
    //     message,
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.hour-cost-item{
  position: relative;
  margin: 0 calc(var(--gap) * 16);
  .contain{
    position: relative;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 70) calc(var(--gap) * 12) 0;
    color: var(--g7);
    background: var(--white);
    overflow: hidden;
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    .class-status{
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      top: 12px;
      right: 0;
      bottom: 12px;
      width: 70px;
      overflow: hidden;
      color: var(--g6);
      border-left: 1px solid var(--g3);
      .status-name {
        color: var(--g8);
        font-weight: var(--bold);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        margin-bottom: calc(var(--gap) * 4);
        .makeup {
          color: var(--g6);
          font-size:var(--fs-xs);
          line-height:var(--lh-xs);
        }
      }
      .hour-cost{
        color: var(--c4);
      }
      >span{
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
    }
    .time, .cname{
      margin: 0 0 calc(var(--gap) * 4);
    }
    .time {
      font-weight: bold;
    }
    .cname {
      color: var(--g6);
    }
    .class-infos {
      display: flex;
      color: var(--g6);
      >div {
        &:first-child{
          margin-right: calc(var(--gap) * 12);
          min-width: 70px;
        }
        >.van-icon,
        >.vxs-icon {
          vertical-align: bottom;
        }
      }
    }
    .course-content {
      color: var(--g6);
      margin-top: 2px;
    }
    &::before{
      content: "";
      position:absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 1px;
      background-color: var(--g3);
      transform: scaleY(0.5);
    }
  }
  &:first-child>.contain::before{
    display: none;
  }
}
</style>